// @ts-ignore
/* eslint-disable */
import request from "src/lib/axios";

/** 获取当前用户资料 GET /api/v1/dashboard/profile */
export async function DashboardProfileControllerGetProfileV1(options?: {
  [key: string]: any;
}) {
  return request<MyApi.ApiResponseOutputUserDto>("/api/v1/dashboard/profile", {
    method: "GET",
    ...(options || {}),
  });
}

/** 更新当前用户资料 PUT /api/v1/dashboard/profile */
export async function DashboardProfileControllerUpdateProfileV1(
  body: MyApi.UpdateUserProfileInfoDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputUserDto>("/api/v1/dashboard/profile", {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 修改密码 PUT /api/v1/dashboard/profile/password */
export async function DashboardProfileControllerChangePasswordV1(
  body: MyApi.UpdatePasswordDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseBoolean>(
    "/api/v1/dashboard/profile/password",
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 修改手机号（原号与新号均需短信验证，新号不可已被注册） PUT /api/v1/dashboard/profile/phone */
export async function DashboardProfileControllerChangePhoneV1(
  body: MyApi.ChangePhoneDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputUserDto>(
    "/api/v1/dashboard/profile/phone",
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}
